export enum AccountType {
  CUSTOMER = 'customer',
  PROVIDER = 'provider',
}
